import script from "./GameTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTrade.vue?vue&type=script&setup=true&lang=js"

import "./GameTrade.vue?vue&type=style&index=0&id=d46c7ea8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d46c7ea8"]])

export default __exports__